import * as React from 'react';
import { Debt, Settlement } from '../../../models/debt';
import SettlementOverviewForm from './SettlementOverviewForm/SettlementOverviewForm';
import Button from '@material-ui/core/Button/Button';
import * as styles from './SettlementOverview.css';
import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';

interface SettlementOverviewProps {
  debt: Debt;
  onStateSubmit: (settlement: Settlement) => void;
}

interface SettlementOverviewState {
  settingState: boolean;
}

class SettlementOverview extends React.Component<SettlementOverviewProps, SettlementOverviewState> {
  constructor(props: SettlementOverviewProps) {
    super(props);
    this.state = { settingState: false };
  }

  public render() {
    const { debt, onStateSubmit } = this.props;
    return (
      <>
        {debt.negotiatedAmount || this.state.settingState ? (
          <Grid item container xs={12}>
            <Grid item container justify="center">
              <Typography color="primary" variant="headline" className={styles.header}>
                <b>SETTLEMENT OVERVIEW</b>
              </Typography>
            </Grid>
            <Grid item container justify="center">
              <Grid item xs={11} sm={10}>
                <SettlementOverviewForm
                  enableReinitialize
                  initialValues={{
                    enrolledBalance: Number(debt.enrolledBalance).toFixed(2),
                    balanceAtSettlement: Number(debt.balanceAtSettlement).toFixed(2),
                    balance: Number(debt.balance).toFixed(2),
                    negotiatedAmount: Number(debt.negotiatedAmount).toFixed(2),
                    settlementDate: debt.settlementDate,
                    discountPercent: Number(debt.discountPercent * 100).toFixed(2)
                  }}
                  initialEditing={this.state.settingState}
                  onSubmit={(updatedSettlement: Settlement) => onStateSubmit(updatedSettlement)}
                />
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <Button
            size="large"
            className={styles.button}
            variant="contained"
            color="primary"
            onClick={() => {
              return this.setState({ settingState: true });
            }}>
            Add Settlement
          </Button>
        )}
      </>
    );
  }
}

export default SettlementOverview;
